module.exports = __webpack_public_path__ + "info-icon-yellow.3109bff3bb838881455b7dfca598c650.svg";